export const DOCUMENT_TYPE_NEMND_FRONTPAGE = 'nemnd-frontpage';
